import React from "react";

const SocialIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26.009"
      height="26.011"
      viewBox="0 0 26.009 26.011"
    >
      <g id="db6" transform="translate(-3.005 -3)">
        <path
          id="Path_1156"
          data-name="Path 1156"
          d="M3.888,20.248a7.758,7.758,0,0,0,.882,3.588,4.643,4.643,0,0,1,3.165-3.341,7.36,7.36,0,0,0,3.006.65,8,8,0,0,0,7.934-8.072A8,8,0,0,0,10.94,5C6.167,5,3.116,9.381,3.006,13.072a7.8,7.8,0,0,0,1.358,4.512,7.755,7.755,0,0,0-.476,2.664ZM10.94,7.691A1.794,1.794,0,1,1,9.177,9.485,1.794,1.794,0,0,1,10.94,7.691ZM8.3,13.969a1.794,1.794,0,0,1,1.794-1.794h1.683a1.813,1.813,0,0,1,1.813,1.813v4.466H8.3Z"
          transform="translate(0 -1.103)"
          fill={fill ? fill : "#000"}
        />
        <path
          id="Path_1157"
          data-name="Path 1157"
          d="M45.747,3a4.447,4.447,0,1,0,4.409,4.485A4.447,4.447,0,0,0,45.747,3Zm2.481,4.969a4.579,4.579,0,0,1-2.481,2.655,4.579,4.579,0,0,1-2.481-2.655,2.545,2.545,0,0,1,0-1.77,1.551,1.551,0,0,1,.827-.885,1.223,1.223,0,0,1,.827,0,1.471,1.471,0,0,1,.827.885,1.471,1.471,0,0,1,.827-.885,1.223,1.223,0,0,1,.827,0,1.551,1.551,0,0,1,.827.885,2.545,2.545,0,0,1,0,1.77Z"
          transform="translate(-21.142 0)"
          fill={fill ? fill : "#000"}
        />
        <path
          id="Path_1158"
          data-name="Path 1158"
          d="M40.188,33a5.392,5.392,0,1,0,0,10.763,5.691,5.691,0,0,0,2.171-.434,3.494,3.494,0,0,1,1.649,1.031,3.091,3.091,0,0,1,.637,1.2,4.865,4.865,0,0,0,.637-2.392,4.812,4.812,0,0,0-.344-1.776,4.93,4.93,0,0,0,.98-3.008A5.774,5.774,0,0,0,40.188,33Zm-1.762,7.766H36.662V37.178h1.763Zm6.187-1.78a1.765,1.765,0,0,1-1.75,1.78H39.322V37.178c1.445-.748,1.757-1.363,1.763-1.794.005-.348-.186-.689,0-.9a.755.755,0,0,1,.882,0c.484.338.464,1.409,0,2.691H43.8a.82.82,0,0,1,.813.827Z"
          transform="translate(-17.347 -16.546)"
          fill={fill ? fill : "#000"}
        />
      </g>
    </svg>
  );
};

export default SocialIcon;
